import React from 'react'
import {
  LocationArrangementMap,
  LocationArrangementConfig,
  Location,
} from 'services/api/entities/catalog/location/types/internal/location-models'
import { filterObject, keys } from 'services/utils'
import { GetSourceFn } from 'types/common'
import LocalizedSelectInput from 'ui-shared/LocalizedFields/LocalizedSelectInput'
import { WithSelectedProduct } from '../types'

// here we extract only the arrangements with the status active
const getActiveArrangements = (arrangements: LocationArrangementMap) =>
  filterObject(
    (v: LocationArrangementConfig) => v.status === 'active',
    arrangements
  )

const getArrangementsInputChoices = (arrangements: LocationArrangementMap) =>
  keys(getActiveArrangements(arrangements)).map((key) => ({
    name: key,
    id: key,
  }))

type Props = Partial<WithSelectedProduct<Location>> & {
  getSource?: GetSourceFn
}

const LocationPresetAdditionalFields: React.FC<Props> = ({
  getSource,
  selectedProduct,
}) => {
  if (!selectedProduct) return null

  const arrangements = getArrangementsInputChoices(selectedProduct.arrangements)

  return (
    (!!arrangements.length && (
      <LocalizedSelectInput
        label="resources.arrangements"
        source={getSource!('arrangement')}
        choices={arrangements}
      />
    )) ||
    null
  )
}

export default LocationPresetAdditionalFields
